import React from 'react';
import { formatETA } from '../../Helpers/functions/TimesFormat';

const etaDraftValueByOrderId = new Map();

function ETAUpdate({ handleOrderETAUpdate, order }) {
  const orderId = order && order.order_id ? String(order.order_id) : 'unknown';
  const displayEta = formatETA(order && order.estimated_arrival_time) || 'N/A';

  const handleEditEta = () => {
    const initialEta = etaDraftValueByOrderId.has(orderId)
      ? etaDraftValueByOrderId.get(orderId)
      : (formatETA(order && order.estimated_arrival_time) || '');

    const nextEta = window.prompt('Enter ETA', initialEta);
    if (nextEta === null) {
      return;
    }

    const normalizedEta = String(nextEta).trim();
    etaDraftValueByOrderId.set(orderId, normalizedEta);
    handleOrderETAUpdate(order, normalizedEta);
  };

  return (
    <div className="dispatch-realtime-interaction" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
      <label style={{ marginTop: '8px', marginRight: '8px', color: 'white' }}>
        ETA:
      </label>
      <input
        type="text"
        value={displayEta}
        readOnly
        style={{ width: '66%', marginRight: '8px', cursor: 'default' }}
      />
      <button type="button" className="btn btn-info btn-sm" onClick={handleEditEta}>
        Edit ETA
      </button>
    </div>
  );
}

export default ETAUpdate;
